import React, { useState } from 'react';
import api from '../api/client';

export default function SubscribeBanner() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error | conflict
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || status === 'done') return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await api.post('/api/public/subscribe', { email });
      setStatus('done');
    } catch (err) {
      const httpStatus = err.response?.status;
      setStatus(httpStatus === 409 ? 'conflict' : 'error');
    }
  };

  return (
    <div className="pub-subscribe-banner">
      <div className="pub-subscribe-banner-content">
        <span className="pub-subscribe-banner-text">
          🐻 새 글이 올라오면 이메일로 받아보세요
        </span>
        {status === 'conflict' ? (
          <span className="pub-subscribe-banner-msg conflict">이미 구독 중인 이메일입니다.</span>
        ) : (
          <form onSubmit={handleSubmit} className="pub-subscribe-banner-form">
            <input
              type="email"
              placeholder="이메일 주소"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={status === 'loading'}
            />
            <button type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? '...' : '구독'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <span className="pub-subscribe-banner-msg error">오류가 발생했습니다. 다시 시도해 주세요.</span>
        )}
      </div>
      <button
        className="pub-subscribe-banner-dismiss"
        onClick={() => setDismissed(true)}
        aria-label="닫기"
      >
        ✕
      </button>
    </div>
  );
}
